:host {
  display: block;
}

::slotted(joy-collapse-item) {
  padding-top: var(--joy-core-spacing-3);
}

::slotted(:not(joy-collapse-item:last-child)) {
  border-bottom: 1px solid var(--joy-color-neutral-30);
}